import { render } from "./DatabaseConcept.vue?vue&type=template&id=5620dc4b&scoped=true"
import script from "./DatabaseConcept.vue?vue&type=script&lang=js"
export * from "./DatabaseConcept.vue?vue&type=script&lang=js"

import "./DatabaseConcept.vue?vue&type=style&index=0&id=5620dc4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5620dc4b"]])

export default __exports__